module.exports = __webpack_public_path__ + "img/banner04_info_pic.82b29bf1.jpg";